import React from 'react';

export default function StudioProportionChart({value,title,type='pie',compact=false}) {
  const share=Math.max(0,Math.min(100,value)),radius=18,circumference=2*Math.PI*radius;
  const angle=share/100*Math.PI*2;
  const x=24+radius*Math.sin(angle),y=24-radius*Math.cos(angle);
  return <div className={`--TSD-chart --TSD-chart--radial${compact?' --TSD-chart--compact':''}`} data-chart-type={type}>
    <svg viewBox="0 0 48 48" role="img" aria-label={`${title}: ${share.toFixed(1)} percent (${type==='donut'?'doughnut':'pie'} chart)`}>
      {type==='pie'?<>
        <circle className="--TSD-pie-remainder" cx="24" cy="24" r={radius}/>
        {share===100?<circle className="--TSD-pie-value" cx="24" cy="24" r={radius}/>:share>0?<path className="--TSD-pie-value" d={`M 24 24 L 24 ${24-radius} A ${radius} ${radius} 0 ${share>50?1:0} 1 ${x} ${y} Z`}/>:null}
      </>:<>
        <circle className="--TSD-chart-radial-track" cx="24" cy="24" r={radius}/>
        <circle className="--TSD-chart-radial-value" cx="24" cy="24" r={radius} strokeDasharray={`${share/100*circumference} ${circumference-share/100*circumference}`} transform="rotate(-90 24 24)"/>
        <text className="--TSD-chart-radial-label" x="24" y="26" textAnchor="middle">{share.toFixed(0)}%</text>
      </>}
    </svg>
    {!compact&&<div className="--TSD-proportion-legend"><span><i/>{share.toFixed(1)}%</span><span><i/>{(100-share).toFixed(1)}% remaining</span></div>}
  </div>;
}
